module.exports = require("co");


//////////////////
// WEBPACK FOOTER
// external "co"
// module id = 5
// module chunks = 0